import { render } from "./editWattMinLayerModal.vue?vue&type=template&id=d66d6c72&ts=true"
import script from "./editWattMinLayerModal.vue?vue&type=script&lang=ts"
export * from "./editWattMinLayerModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__